// import Vue from "vue";
// import VueRouter from "vue-router";
import { createRouter, createWebHistory } from 'vue-router'
import store from "../store";
import OuterLayout from "../layouts/OuterLayout.vue";
import MainLayout from "../layouts/MainLayout.vue";
import Register from "../views/Auth/Register.vue";
import Login from "../views/Auth/Login.vue";
import ResetPassword from "../views/Auth/ResetPassword.vue";
import Dashboard from "../views/Pages/Dashboard.vue";
import EmployeeDashboard from "../views/Pages/EmployeeDashboard.vue";
import ParentDashboard from "../views/Pages/ParentDashboard.vue";
import Settings from "../views/Pages/Settings.vue";
import ProfileSettingsPage from "../components/settings/ProfileSettingsPage.vue";
import PasswordSettingsPage from "../components/settings/PasswordSettingsPage.vue";
import TeachingSettingsPage from "../components/settings/TeachingSettingsPage.vue";
import AppearanceSettingsPage from "../components/settings/AppearanceSettingsPage.vue";
import RegisterSuccess from "../views/Auth/RegisterSuccess.vue";
import UserType from "../views/Pages/UserType.vue";
import AccountVerification from "../views/Pages/AccountVerification.vue";
import Users from "../views/Pages/Users.vue";
import SchoolSettings from "../views/Pages/SchoolSettings.vue";
// Superadmin only (the server checks too), so not under /employee.
import ActivityLog from "../views/Pages/ActivityLog.vue";
import RoomStudents from "../views/Pages/RoomStudents.vue";
import UserModules from "../views/Pages/UserModules.vue";
import ModulesList from "../views/Pages/ModulesList.vue";
import NotFound from "../views/Pages/NotFound.vue";
import EnrollStudents from "../views/Pages/EnrollStudents.vue";
import Students from "../views/Pages/Students.vue";
import CreateSubject from "../views/Pages/CreateSubject.vue";
import HighSchoolRooms from "../views/Pages/AddRoomsSection.vue";
import AddTracks from "../views/Pages/AddTracks.vue";
import AddStrands from "../views/Pages/AddStrands.vue";
import StudentEnroll from "../views/Auth/StudentEnroll.vue";
import StudentEnrollSuccess from "../views/Auth/StudentEnrollSuccess.vue";
import ClassroomProgram from "../views/Pages/ClassroomProgram.vue";
import AvailableFaculty from "../views/Pages/AvailableFaculty.vue";
import MyScheduledProgram from "../views/Pages/MyScheduledProgram.vue";
import AddSchoolYear from "../views/Pages/AddSchoolYear.vue";
import AddElementaryRooms from "../views/Pages/AddElementaryRooms.vue";
import ElementaryProgram from "../views/Pages/ElementaryProgram.vue";
import LandingPage from "../views/Auth/LandingPage.vue";
import ChangePassword from "../views/Auth/ChangePassword.vue";
import { areaFor, CHANGE_PASSWORD_PATH } from "@/api/session";
import TeachersListGradeLevel from "../views/Pages/TeachersListGradeLevel.vue";
import ElementaryTeacherListGradeLevel from "../views/Pages/ElementaryTeacherListGradeLevel.vue";
import AdviserRoomAssign from '../views/Pages/AdviserRoomAssign.vue';
import MyStudentsRecord from '../views/Pages/MyStudentsRecord.vue';
import TransmutedGrade from '../views/Pages/TransmutedGrade.vue';
import FacultyList from '../views/Pages/FacultyList.vue';
import StudentDiscipline from '../views/Pages/StudentDiscipline.vue';
import ParentChildren from '../views/Pages/ParentChildren.vue';
import AdvisoryProgram from '../views/Pages/AdvisoryProgram.vue';
import Events from '../views/Pages/Events.vue';
import Announcement from '../views/Pages/Announcement.vue';
import MyReports from '../views/Pages/MyReports.vue';
import DepEdPersonnel from '@/views/Pages/DepEdPersonnel.vue';
import ParentEsignature from '@/views/Pages/ParentEsignature.vue';
import TeacherAppointment from '@/views/Pages/TeacherAppointment.vue';
// Vue.use(VueRouter);

// Personal settings, mounted under each area (/admin, /superadmin,
// /employee, /parent). The old /profile address now opens Settings → Profile.
const settingsMeta = { title: "Settings", authRequired: true, hideYearPicker: true };
const settingsRoutes = () => [
  {
    path: "settings",
    component: Settings,
    meta: settingsMeta,
    redirect: (to) => `${to.path.replace(/\/$/, "")}/profile`,
    children: [
      { path: "profile", component: ProfileSettingsPage, meta: settingsMeta },
      { path: "password", component: PasswordSettingsPage, meta: settingsMeta },
      { path: "teaching", component: TeachingSettingsPage, meta: settingsMeta },
      { path: "appearance", component: AppearanceSettingsPage, meta: settingsMeta },
    ],
  },
  {
    path: "profile",
    redirect: (to) => to.path.replace(/profile\/?$/, "settings/profile"),
  },
];

const routes = [
  {
    path: "/",
    component: OuterLayout,
    meta: { authRequired: false },
    children: [
      {
        path: "",
        component: LandingPage,
        meta: { authRequired: false },
      },
      // The home page used to live at /landing; keep old links working.
      { path: "landing", redirect: "/" },
      // First sign-in with a password an admin set (see JWTAuthGuard).
      {
        path: "change-password",
        component: ChangePassword,
        meta: { authRequired: false },
      },
      {
        path: "login",
        alias: "/login",
        component: Login,
        meta: { authRequired: false },
      },
      {
        path: "register",
        component: Register,
        meta: { authRequired: false },
      },
      {
        path: "registration-success",
        component: RegisterSuccess,
        meta: { authRequired: false },
      },
      {
        path: "enroll-success",
        component: StudentEnrollSuccess,
        meta: { authRequired: false },
      },
      {
        path: "forgot-password",
        component: ResetPassword,
        meta: { authRequired: false },
      },
      {
        path: "student-enroll",
        component: StudentEnroll,
        meta: {authRequired: false },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
    meta: { authRequired: false },
  },
  //admin
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    meta: { RouteForAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true, hideYearPicker: true },
      },
      // The built-in superadmin has user type 1, so it browses under /admin
      // like admins do; the page itself checks the School Settings grant.
      {
        path: "school-settings",
        component: SchoolSettings,
        meta: { title: "School Settings", authRequired: true, hideYearPicker: true },
      },
      {
        path: "dashboard",
        component: Dashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "subjects",
        component: CreateSubject,
        meta: { title: "Subjects", authRequired: true },
      },
      {
        path: "high-school-rooms",
        component: HighSchoolRooms,
        meta: { title: "Rooms", authRequired: true },
      },
      {
        path: "high-school-rooms/:id/students",
        component: RoomStudents,
        meta: { title: "Class list", authRequired: true },
      },

      {
        path: "elementary-rooms",
        component: AddElementaryRooms,
        meta: { title: "Add Elementary Rooms", authRequired: true },
      },


      {
        path: "tracks",
        component: AddTracks,
        meta: { title: "Tracks", authRequired: true },
      },
      {
        path: "strands",
        component: AddStrands,
        meta: { title: "Strands", authRequired: true },
      },

      {
        path: "accounts",
        component: AccountVerification,
        meta: { title: "Account Verification", authRequired: true },
      },
      {
        path: "students",
        component: Students,
        meta: { title: "Students", authRequired: true },
      },
      {
        path: "user-type",
        component: UserType,
        meta: { title: "Utilities - Type of Users", authRequired: true },
      },
      ...settingsRoutes(),
      
      {
        path: "enroll-student",
        component: EnrollStudents,
        meta: { title: "Enroll Students", authRequired: true },
      },    
      {
        path: "modules-list",
        component: ModulesList,
        meta: { title: "Module Management", authRequired: true },
      },

      {
        path: "user-modules",
        component: UserModules,
        meta: { title: "Module Management", authRequired: true },
      },

      {
        path: "classroom-schedules",
        component: ClassroomProgram,
        meta: { title: "Classroom Schedules", authRequired: true },
      },

      {
        path: "elementary-program",
        component: ElementaryProgram,
        meta: { title: "Elementary Program", authRequired: true },
      },

      {
        path: "faculty-schedule",
        component: AvailableFaculty,
        meta: { title: "Faculty Schedule List", authRequired: true },
      },
      {
        path: "teachers-list",
        component: TeachersListGradeLevel,
        meta: { title: "Faculty List", authRequired: true },
      },

      {
        path: "elementary-teachers-list",
        component: ElementaryTeacherListGradeLevel,
        meta: { title: "Faculty List", authRequired: true },
      },

      {
        path: "my-scheduled-program",
        component: MyScheduledProgram,
        meta: { title: "My Schedule List", authRequired: true },
      },
      {
        path: "school-years",
        component: AddSchoolYear,
        meta: { title: "School Years", authRequired: true },
      },

      {
        path: "users",
        component: Users,
        meta: { title: "Utilities - Users", authRequired: true },
      },

       {
        path: "transmuted-grade",
        component: TransmutedGrade,
        meta: { title: "Transmuted Grade", authRequired: true },
      },
      {
        path: "faculty-list",
        component: FacultyList,
        meta: { title: "Faculty List", authRequired: true },
      },
      {
        path: "events",
        component: Events,
        meta: { title: "Events", authRequired: true },
      },
      {
        path: "announcement",
        component: Announcement,
        meta: { title: "Announcement", authRequired: true },
      },
      {
        path: "deped-personnel",
        component: DepEdPersonnel,
        meta: { title: "DepEd Personnels", authRequired: true },
      },
      
      
      // {
      //   path: "404",
      //   component: NotFound,
      //   meta: { authRequired: true },
      // },
    ],
  },
  //superadmin]
  {
    path: "/superadmin",
    redirect: "/superadmin/dashboard",
    meta: { RouteForSuperAdmin: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        path: "activity-log",
        component: ActivityLog,
        meta: { title: "Activity Log", authRequired: true, hideYearPicker: true },
      },
      {
        path: "school-settings",
        component: SchoolSettings,
        meta: { title: "School Settings", authRequired: true, hideYearPicker: true },
      },
      {
        path: "dashboard",
        component: Dashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      {
        path: "students",
        component: Students,
        meta: { title: "Students", authRequired: true },
      },
      {
        path: "enroll-student",
        component: EnrollStudents,
        meta: { title: "Enroll Students", authRequired: true },
      },
      {
        path: "user-type",
        component: UserType,
        meta: { title: "Utilities - Type of Users", authRequired: true },
      },
      ...settingsRoutes(),
      {
        path: "user-modules",
        component: UserModules,
        meta: { title: "Module Management", authRequired: true },
      },
      {
        path: "modules-list",
        component: ModulesList,
        meta: { title: "Module Management", authRequired: true },
      },
      {
        path: "accounts",
        component: AccountVerification,
        meta: { title: "Account Verification", authRequired: true },
      },
      {
        path: "my-scheduled-program",
        component: MyScheduledProgram,
        meta: { title: "My Schedule List", authRequired: true },
      },
      {
        path: "users",
        component: Users,
        meta: { title: "Utilities - Users", authRequired: true },
      },
      {
        path: "announcement",
        component: Announcement,
        meta: { title: "Announcement", authRequired: true },
      },
      {
        // The superadmin posts the events shown on the landing page.
        path: "events",
        component: Events,
        meta: { title: "Events", authRequired: true },
      },

      
      



    ],
  },
  //employee
  {
    path: "/employee",
    meta: { RouteForEmployee: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        // Not path "/employee": a child with its parent's path makes the
        // sidebar's Dashboard link look active on every /employee page.
        path: "dashboard",
        alias: "/employee",
        component: EmployeeDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      ...settingsRoutes(),
      {
        path: "faculty-list",
        component: FacultyList,
        meta: { title: "Faculty List", authRequired: true },
      },
      {
        path: "accounts",
        component: AccountVerification,
        meta: { title: "Account Verification", authRequired: true },
      },
      {
        path: "faculty-schedule",
        component: AvailableFaculty,
        meta: { title: "Faculty Schedule List", authRequired: true },
      },
      {
        path: "transmuted-grade",
        component: TransmutedGrade,
        meta: { title: "Transmuted Grade", authRequired: true },
      },
      {
        path: "school-years",
        component: AddSchoolYear,
        meta: { title: "School Years", authRequired: true },
      },
      {
        path: "tracks",
        component: AddTracks,
        meta: { title: "Tracks", authRequired: true },
      },
      {
        path: "strands",
        component: AddStrands,
        meta: { title: "Strands", authRequired: true },
      },
      {
        path: "subjects",
        component: CreateSubject,
        meta: { title: "Subjects", authRequired: true },
      },
      {
        path: "high-school-rooms",
        component: HighSchoolRooms,
        meta: { title: "Rooms", authRequired: true },
      },
      {
        path: "high-school-rooms/:id/students",
        component: RoomStudents,
        meta: { title: "Class list", authRequired: true },
      },
      {
        path: "students",
        component: Students,
        meta: { title: "Students", authRequired: true },
      },
      {
        path: "enroll-student",
        component: EnrollStudents,
        meta: { title: "Enroll Students", authRequired: true },
      },
      {
        path: "my-scheduled-program",
        component: MyScheduledProgram,
        meta: { title: "My Schedule List", authRequired: true },
      },

      {
        path: "elementary-rooms",
        component: AddElementaryRooms,
        meta: { title: "Add Elementary Rooms", authRequired: true },
      },
      
      {
        path: "advisory-rooms",
        component: AdviserRoomAssign,
        meta: { title: "My Advisory Class", authRequired: true },
      },
      {
        path: "students-records",
        component: MyStudentsRecord,
        meta: { title: "Class Records", authRequired: true },
      },
      {
        path: "classroom-schedules",
        component: ClassroomProgram,
        meta: { title: "Classroom Schedules", authRequired: true },
      },
      {
        path: "student-discipline",
        component: StudentDiscipline,
        meta: { title: "Discipline Records", authRequired: true },
      },
      {
        path: "advisory-schedule",
        component: AdvisoryProgram,
        meta: { title: "Advisory Schedule", authRequired: true },
      },
      {
        path: "events",
        component: Events,
        meta: { title: "Events", authRequired: true },
      },
      {
        path: "announcement",
        component: Announcement,
        meta: { title: "Announcement", authRequired: true },
      },
      {
        path: "my-reports",
        component: MyReports,
        meta: { title: "Reported Students", authRequired: true },
      },
      {
        path: "deped-personnel",
        component: DepEdPersonnel,
        meta: { title: "DepEd Personnels", authRequired: true },
      },
      {
        path: "e-signature",
        component: ParentEsignature,
        meta: { title: "E-signature", authRequired: true },
      },
      {
        path: "appointments",
        component: TeacherAppointment,
        meta: { title: "Appointments", authRequired: true },
      }
      
      
      
    ],
  },
  //parent
  // Parents and guardians have their own area: they aren't staff, so their
  // pages don't live under /employee.
  {
    path: "/parent",
    meta: { RouteForParent: true, authRequired: true },
    component: MainLayout,
    children: [
      {
        // Not path "/parent", for the same reason as the employee dashboard.
        path: "dashboard",
        alias: "/parent",
        component: ParentDashboard,
        meta: { title: "Dashboard", authRequired: true },
      },
      ...settingsRoutes(),
      {
        path: "my-children",
        component: ParentChildren,
        meta: { title: "My Children Record", authRequired: true },
      },
      {
        path: "e-signature",
        component: ParentEsignature,
        meta: { title: "E-signature", authRequired: true },
      },
    ],
  },
];

// Page addresses that were renamed (to full words, or to a more general
// name). The old ones redirect so bookmarks and saved notification links
// keep working.
const RENAMED_PATHS = {
  acc_verify: "accounts",
  student_verify: "students",
  "forgot-pw": "forgot-password",
  Esignature: "e-signature",
  "advisory-programm": "advisory-schedule",
  "classroom-programm": "classroom-schedules",
  "elementary-programm": "elementary-program",
  "elementarty-teachers-list": "elementary-teachers-list",
  "deped-personnels": "deped-personnel",
  "add-school-year": "school-years",
  "add-strands": "strands",
  "add-tracks": "tracks",
  "create-subject": "subjects",
  "parent-children": "my-children",
  "teacher-appointment": "appointments",
};
for (const area of routes) {
  const children = area.children ?? [];
  for (const [oldPath, newPath] of Object.entries(RENAMED_PATHS)) {
    if (children.some((child) => child.path === newPath)) {
      children.push({
        path: oldPath,
        // Paths match regardless of case (/Esignature, /esignature), so the
        // replacement must too, or the redirect would land on itself.
        redirect: (to) => ({ path: to.path.replace(new RegExp(`${oldPath}/?$`, "i"), newPath), query: to.query }),
      });
    }
  }
}

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.getIsAuthenticated;
  const needsAuth = to.matched.some((record) => record.meta.authRequired == true);
  // Someone signed in with an admin-set password chooses their own first, and
  // that page is the only one open to them. It must be let through here: the
  // area check below sends signed-in users on public pages to their
  // dashboard, which would bounce straight back here forever.
  if (isAuthenticated && Number(store.state.user?.user?.mustChangePassword)) {
    return to.path.toLowerCase() === CHANGE_PASSWORD_PATH ? next() : next(CHANGE_PASSWORD_PATH);
  }
  if (!isAuthenticated) return needsAuth ? next("/") : next();

  // Signed-in users stay in their own area; anywhere else (including the
  // public pages) sends them to their dashboard.
  const area = areaFor(store.state.user);
  const [, first = "", ...rest] = to.path.split("/");
  if (first.toLowerCase() === area) return next();
  // Parents used to browse under /employee: old links open the same page
  // under /parent when it exists there.
  if (area === "parent" && first.toLowerCase() === "employee") {
    const moved = router.resolve({ path: `/parent/${rest.join("/")}`, query: to.query });
    if (moved.matched.some((record) => record.meta.RouteForParent)) return next(moved.fullPath);
  }
  next(`/${area}/dashboard`);
});
export default router;
